/* =========================================================
   Evergreen — offre limitée, popup newsletter, palier cadeau
   Chargé après theme.js (defer). Réglages : window.evSettings (layout/theme.liquid).
   ========================================================= */
(function () {
  'use strict';
  var S = window.evSettings || {};

  function store(type) {
    try { var s = window[type]; s.setItem('__ev', '1'); s.removeItem('__ev'); return s; } catch (e) { return null; }
  }
  var local = store('localStorage');
  var session = store('sessionStorage');

  /* ---------- Copier un code promo ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ev-copy]');
    if (!btn) return;
    var code = btn.getAttribute('data-ev-copy');
    var done = function () {
      var old = btn.textContent;
      btn.textContent = 'Copiat ✓';
      setTimeout(function () { btn.textContent = old; }, 1600);
    };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
  });

  /* ---------- Vidéos chargées à l'approche de l'écran (économise les données mobiles) ---------- */
  var lazyVideos = document.querySelectorAll('video[data-ev-lazy-video]');
  var startVideo = function (v) {
    v.querySelectorAll('source[data-src]').forEach(function (s) { s.src = s.getAttribute('data-src'); s.removeAttribute('data-src'); });
    v.load();
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  };
  if (lazyVideos.length) {
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { vio.unobserve(e.target); startVideo(e.target); } });
      }, { rootMargin: '200px 0px' });
      lazyVideos.forEach(function (v) { vio.observe(v); });
    } else {
      lazyVideos.forEach(startVideo);
    }
  }

  /* ---------- Catégorie active dans les tuiles des collections ---------- */
  document.querySelectorAll('.ev-tiles--scroll .ev-tile').forEach(function (tile) {
    var href = tile.getAttribute('href') || '';
    var here = decodeURIComponent(location.pathname + location.search);
    var target = decodeURIComponent(href);
    var tagMatch = /filter\.p\.tag=([^&]+)/.exec(target);
    var active = tagMatch ? here.indexOf('filter.p.tag=' + tagMatch[1]) !== -1 : (target !== '' && location.pathname === target);
    if (active) { tile.classList.add('is-active'); tile.setAttribute('aria-current', 'page'); }
  });

  /* ---------- Offre limitée + compte à rebours ---------- */
  // "2026-10-05 23:59" interprété à l'heure de Bucarest
  function bucharestTime(str) {
    var m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/.exec((str || '').trim());
    if (!m) return null;
    var utcGuess = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
    var offset;
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Europe/Bucharest', hourCycle: 'h23',
        year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'
      }).formatToParts(new Date(utcGuess));
      var get = function (t) { return +parts.find(function (p) { return p.type === t; }).value; };
      offset = Date.UTC(get('year'), get('month') - 1, get('day'), get('hour'), get('minute')) - utcGuess;
    } catch (e) { offset = 3 * 3600000; }
    return utcGuess - offset;
  }

  var offerStart = bucharestTime(S.offerStart);
  var offerEnd = bucharestTime(S.offerEnd);
  var pad = function (n) { return n < 10 ? '0' + n : String(n); };

  function tickOffer() {
    var now = Date.now();
    var active = !!(S.offerEnabled && offerEnd && now < offerEnd && (!offerStart || now >= offerStart));
    document.querySelectorAll('[data-ev-offer]').forEach(function (el) { el.hidden = !active; });
    document.documentElement.classList.toggle('ev-offer-active', active);
    if (!active) return false;
    var left = Math.max(0, Math.floor((offerEnd - now) / 1000));
    var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
    document.querySelectorAll('[data-ev-countdown]').forEach(function (cd) {
      var set = function (k, v) { var b = cd.querySelector('[data-ev-cd="' + k + '"]'); if (b) b.textContent = v; };
      set('d', d); set('h', pad(h)); set('m', pad(m)); set('s', pad(s));
      var dayUnit = cd.querySelector('[data-ev-cd="d"]');
      if (dayUnit) dayUnit.parentNode.hidden = d === 0;
    });
    return true;
  }
  if (S.offerEnabled) {
    tickOffer();
    var offerTimer = setInterval(function () {
      if (!tickOffer() && offerEnd && Date.now() >= offerEnd) clearInterval(offerTimer);
    }, 1000);
  }

  /* ---------- Popup newsletter ---------- */
  var popup = document.querySelector('[data-ev-popup]');
  // pas de popup sur la page quiz : le quiz propose déjà son propre formulaire email
  if (popup && !document.querySelector('[data-ev-quiz]')) {
    var DAY = 86400000;
    var days = +popup.getAttribute('data-days') || 14;
    var delay = (+popup.getAttribute('data-delay') || 8) * 1000;
    var success = popup.querySelector('[data-ev-popup-success]');
    var lastFocus = null;

    var cookieBannerVisible = function () {
      var b = document.getElementById('shopify-pc__banner');
      return !!(b && b.offsetParent !== null);
    };
    var openPopup = function () {
      if (!popup.hidden) return;
      // On attend que le visiteur ait répondu à la bannière cookies
      if (!success && cookieBannerVisible()) { setTimeout(openPopup, 4000); return; }
      lastFocus = document.activeElement;
      popup.hidden = false;
      document.documentElement.classList.add('ev-popup-open');
      requestAnimationFrame(function () { popup.classList.add('is-open'); });
      var field = popup.querySelector('input[type="email"], .ev-code, .ev-btn');
      if (field) setTimeout(function () { field.focus({ preventScroll: true }); }, 250);
      if (session) session.setItem('evPopupShown', '1');
    };
    var closePopup = function () {
      popup.classList.remove('is-open');
      document.documentElement.classList.remove('ev-popup-open');
      setTimeout(function () { popup.hidden = true; }, 250);
      if (local && !success) local.setItem('evPopupDismissed', String(Date.now()));
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };
    popup.querySelectorAll('[data-ev-popup-close]').forEach(function (b) { b.addEventListener('click', closePopup); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !popup.hidden) closePopup(); });

    if (success) {
      // Retour après inscription : on montre le code et on ne propose plus la popup
      if (local) local.setItem('evSubscribed', '1');
      openPopup();
    } else {
      var dismissed = local ? +local.getItem('evPopupDismissed') || 0 : 0;
      var blocked = (local && local.getItem('evSubscribed')) ||
                    (session && session.getItem('evPopupShown')) ||
                    (Date.now() - dismissed < days * DAY);
      if (!blocked) {
        var timer = setTimeout(openPopup, delay);
        // Ordinateur : la souris quitte la page par le haut
        document.addEventListener('mouseout', function onLeave(e) {
          if (!e.relatedTarget && e.clientY <= 0) {
            clearTimeout(timer);
            openPopup();
            document.removeEventListener('mouseout', onLeave);
          }
        });
      }
    }
  }

  /* ---------- Échantillon cadeau à partir d'un montant ----------
     Réglages : Paramètres du thème → Evergreen – Coș (cadou), transmis par
     window.evCartDrawer.gift (layout/theme.liquid). L'échantillon s'ajoute seul
     quand le panier atteint le seuil et se retire seul en dessous.
     window.evGift est utilisé par la page panier et le panneau « Adăugat în coș ». */
  var gift = window.evCartDrawer && window.evCartDrawer.gift;
  var giftBusy = false;
  var jsonHeaders = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  function money(cents) {
    if (window.Shopify && Shopify.formatMoney && window.theme && theme.moneyFormat) return Shopify.formatMoney(cents, theme.moneyFormat);
    return (cents / 100).toFixed(2) + ' lei';
  }
  function cartJson() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function giftState(cart) {
    var line = null;
    cart.items.forEach(function (i) { if (i.variant_id === gift.variant) line = i; });
    var paid = cart.total_price - (line ? line.final_line_price : 0);
    var others = cart.item_count - (line ? line.quantity : 0);
    return { line: line, paid: paid, left: Math.max(0, gift.threshold - paid), reached: others > 0 && paid >= gift.threshold };
  }
  // Ajoute ou retire l'échantillon selon le montant ; renvoie le panier à jour
  function syncGift(cart) {
    if (!gift || !gift.variant || !gift.autoadd || !cart || !cart.items || giftBusy) return Promise.resolve(cart);
    var s = giftState(cart), request = null;
    if (s.reached && !s.line) request = ['/cart/add.js', { items: [{ id: gift.variant, quantity: 1, properties: { '_Cadou': 'Da' } }] }];
    else if (!s.reached && s.line) request = ['/cart/change.js', { id: s.line.key, quantity: 0 }];
    else if (s.line && s.line.quantity > 1) request = ['/cart/change.js', { id: s.line.key, quantity: 1 }];
    if (!request) return Promise.resolve(cart);
    giftBusy = true;
    return fetch(request[0], { method: 'POST', headers: jsonHeaders, body: JSON.stringify(request[1]) })
      .then(cartJson)
      .then(function (next) { giftBusy = false; return next; }, function () { giftBusy = false; return cart; });
  }
  function giftText(cart) {
    var s = giftState(cart);
    return s.reached ? gift.after : gift.before.replace('{amount}', '<b>' + money(s.left) + '</b>');
  }
  // Barre « cadeau » de l'ancien mini-panier et de l'aperçu rapide du thème
  function giftTiers(cart) {
    document.querySelectorAll('.js-ev-gift').forEach(function (t) {
      var s = giftState(cart);
      t.hidden = cart.item_count === 0;
      t.querySelector('.js-ev-gift-text').innerHTML = giftText(cart);
      t.querySelector('.js-ev-gift-bar').style.width = Math.min(100, s.paid / gift.threshold * 100) + '%';
      t.classList.toggle('is-reached', s.reached);
    });
  }
  window.evGift = gift && gift.variant ? { config: gift, state: giftState, sync: syncGift, text: giftText } : null;

  if (window.evGift) {
    var onCartPage = /^\/cart\/?$/.test(location.pathname);
    var after = function (before, next) {
      giftTiers(next);
      if (next === before) return;
      if (onCartPage) location.reload();
      else if (window.theme && theme.miniCart) { theme.miniCart.generateCart(); theme.miniCart.updateElements(); }
    };
    // Le thème recalcule la barre de livraison à chaque changement du panier : on s'y accroche
    if (window.theme && theme.freeShipping && typeof theme.freeShipping.load === 'function') {
      var originalLoad = theme.freeShipping.load;
      theme.freeShipping.load = function (cart) {
        originalLoad.apply(this, arguments);
        syncGift(cart).then(function (next) { after(cart, next); });
      };
    }
    cartJson().then(function (cart) { return syncGift(cart).then(function (next) { after(cart, next); }); }).catch(function () {});
  }
})();

/* =========================================================
   Carrousel d'accueil (sections/ev-hero-slider.liquid)
   Défilement auto, vidéos légères chargées après la page, swipe, pause.
   ========================================================= */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = function () { return window.matchMedia('(max-width: 749px)').matches; };

  document.querySelectorAll('[data-ev-slider]').forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ev-slide]'));
    var bars = Array.prototype.slice.call(root.querySelectorAll('[data-ev-goto]'));
    if (!slides.length) return;
    var current = 0, timer = null, startedAt = 0, remaining = 0;
    var stopped = root.getAttribute('data-autoplay') !== 'true' || reduceMotion || slides.length < 2;
    var offscreen = false, pageReady = document.readyState === 'complete';
    if (stopped) root.classList.add('is-stopped');

    function videoOf(slide) { return slide.querySelector('[data-ev-slide-video]'); }
    function playVideo(slide) {
      var v = videoOf(slide);
      if (!v || !pageReady) return;
      if (!v.getAttribute('src')) {
        var c = navigator.connection || {};
        var slow = c.saveData || /(^|-)(2g|3g)$/.test(c.effectiveType || '');
        var mobile = isMobile();
        v.src = mobile ? v.getAttribute(slow ? 'data-src-mobile-low' : 'data-src-mobile') : v.getAttribute('data-src-desktop');
        // si une version allégée manque, on repasse sur la version complète
        v.addEventListener('error', function () {
          var fb = v.getAttribute(mobile ? 'data-src-fallback-mobile' : 'data-src-fallback-desktop');
          if (fb && v.src.indexOf(fb) === -1) { v.src = fb; v.play().catch(function () {}); }
        }, { once: true });
      }
      v.addEventListener('playing', function () { v.classList.add('is-playing'); }, { once: true });
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    function pauseVideo(slide) { var v = videoOf(slide); if (v && !v.paused) v.pause(); }
    // Les images de la diapositive (et de la suivante) se chargent tout de suite, pour un fondu sans trou
    function loadImages(slide) {
      if (!slide) return;
      slide.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    }

    function duration(i) { return (+slides[i].getAttribute('data-duration') || 6) * 1000; }
    function schedule(ms) {
      clearTimeout(timer);
      if (stopped || offscreen) return;
      startedAt = Date.now();
      remaining = ms;
      timer = setTimeout(function () { go(current + 1); }, ms);
    }
    function setBar(i) {
      bars.forEach(function (b, n) {
        b.classList.toggle('is-active', n === i);
        b.classList.toggle('is-done', n < i);
        b.setAttribute('aria-selected', n === i ? 'true' : 'false');
        var s = b.querySelector('span');
        if (s) { s.style.animation = 'none'; void s.offsetWidth; s.style.animation = ''; }
        if (n === i) b.style.setProperty('--dur', duration(i) + 'ms');
      });
    }
    function go(i) {
      i = (i + slides.length) % slides.length;
      if (i !== current) {
        slides[current].classList.remove('is-active');
        slides[current].setAttribute('aria-hidden', 'true');
        pauseVideo(slides[current]);
      }
      current = i;
      slides[i].classList.add('is-active');
      slides[i].removeAttribute('aria-hidden');
      loadImages(slides[i]);
      loadImages(slides[(i + 1) % slides.length]);
      playVideo(slides[i]);
      setBar(i);
      schedule(duration(i));
    }
    function freeze() {
      clearTimeout(timer);
      remaining = Math.max(0, remaining - (Date.now() - startedAt));
      root.classList.add('is-paused');
    }
    function resume() {
      root.classList.remove('is-paused');
      if (!stopped && !offscreen) schedule(remaining || duration(current));
    }

    bars.forEach(function (b) { b.addEventListener('click', function () { go(+b.getAttribute('data-ev-goto')); }); });
    var prev = root.querySelector('[data-ev-prev]'), next = root.querySelector('[data-ev-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });

    var pauseBtn = root.querySelector('[data-ev-pause]');
    if (pauseBtn) pauseBtn.addEventListener('click', function () {
      stopped = !stopped;
      root.classList.toggle('is-stopped', stopped);
      pauseBtn.setAttribute('aria-pressed', stopped ? 'true' : 'false');
      pauseBtn.setAttribute('aria-label', stopped ? 'Pornește derularea' : 'Oprește derularea');
      if (stopped) freeze(); else { remaining = 0; resume(); }
    });

    // Glisser au doigt
    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(current + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });

    // Clavier
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') go(current + 1);
      if (e.key === 'ArrowLeft') go(current - 1);
    });

    // Hors écran ou onglet caché : on arrête tout (batterie, données)
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        offscreen = !entries[0].isIntersecting;
        if (offscreen) { freeze(); pauseVideo(slides[current]); } else { playVideo(slides[current]); resume(); }
      }, { threshold: 0.15 }).observe(root);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { freeze(); pauseVideo(slides[current]); } else if (!offscreen) { playVideo(slides[current]); resume(); }
    });

    // La 1re vidéo ne démarre qu'après le chargement de la page (l'image d'aperçu s'affiche avant)
    function onReady() { pageReady = true; loadImages(slides[1]); if (!offscreen) playVideo(slides[current]); }
    if (pageReady) onReady(); else window.addEventListener('load', function () { setTimeout(onReady, 300); });

    setBar(0);
    schedule(duration(0));
  });
})();

/* =========================================================
   Panier plus réactif (page /cart)
   Le thème attendait 0,2 s puis faisait 2 allers-retours serveur avant d'afficher
   la nouvelle quantité. Ici : la quantité change tout de suite, une seule requête,
   et Shopify plafonne lui-même au stock disponible.
   ========================================================= */
(function () {
  'use strict';
  var Q = window.QtySelector;
  if (!Q || !Q.prototype || !window.jQuery) return;
  var $ = window.jQuery;

  Q.prototype.adjustQty = function (evt) {
    var $btn = $(evt.currentTarget);
    var $input = $btn.siblings('.js-qty__input');
    var qty = this.validateQty($input.val());
    var line = $input.attr('data-line');
    qty += $btn.hasClass('js-qty__adjust--minus') ? -1 : 1;
    if (qty <= this.settings.minQty) qty = this.settings.minQty;
    $input.val(qty); // affichage immédiat
    if (this.settings.isCartTemplate) {
      $btn.parent().addClass(this.settings.loadingClass);
      this.updateCartItemPrice(line, qty);
    }
  };

  Q.prototype.updateCartItemPrice = function (line, qty) {
    // court délai pour regrouper les clics rapides en une seule requête
    clearTimeout(this.qtyUpdateTimeout);
    this.qtyUpdateTimeout = setTimeout($.proxy(function () { this.updateItemQuantity(line, qty); }, this), 120);
  };

  Q.prototype.updateItemQuantity = function (line, quantity) {
    var self = this;
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      success: function (cart) { self.updateCartItemCallback(cart); },
      error: function () {
        // stock insuffisant ou autre erreur : on remet la quantité réelle
        var item = theme.cartObject && theme.cartObject.items[line - 1];
        if (item) self.$wrapper.find('.js-qty__input').val(item.quantity);
        self.$wrapper.removeClass(self.settings.loadingClass);
      }
    });
  };
})();

/* =========================================================
   Fiche produit : remise quantité, livraison, routine, bouton fixe mobile
   ========================================================= */
(function () {
  'use strict';
  function money(cents) {
    if (window.Shopify && Shopify.formatMoney && window.theme && theme.moneyFormat) return Shopify.formatMoney(cents, theme.moneyFormat);
    return (cents / 100).toFixed(2) + ' lei';
  }
  function currentVariantId(sectionId) {
    var sel = document.getElementById('ProductSelect-' + sectionId);
    return sel ? sel.value : null;
  }

  /* ---------- Remise quantité ---------- */
  document.querySelectorAll('[data-ev-qty]').forEach(function (box) {
    var sectionId = box.getAttribute('data-section');
    var prices = {};
    try { prices = JSON.parse(box.querySelector('[data-ev-qty-variants]').textContent); } catch (e) {}
    var options = box.querySelectorAll('.ev-qty__option');
    // Le thème peut recréer le champ quantité : on le relit à chaque fois
    var getQtyInput = function () {
      var form = document.getElementById('AddToCartForm-' + sectionId);
      return form ? form.querySelector('input[name="quantity"]') : null;
    };

    function select(opt) {
      options.forEach(function (o) {
        o.classList.toggle('is-selected', o === opt);
        o.setAttribute('aria-pressed', o === opt ? 'true' : 'false');
      });
      var qtyInput = getQtyInput();
      if (qtyInput) {
        qtyInput.value = opt.getAttribute('data-qty');
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    function refreshPrices() {
      var price = prices[currentVariantId(sectionId)];
      if (!price) return;
      options.forEach(function (o) {
        var q = +o.getAttribute('data-qty'), off = +o.getAttribute('data-off');
        var full = price * q, fin = Math.round(full * (100 - off) / 100);
        var f = o.querySelector('[data-ev-qty-final]'), s = o.querySelector('[data-ev-qty-full]');
        if (f) f.textContent = money(fin);
        if (s) s.textContent = money(full);
      });
    }
    options.forEach(function (o) { o.addEventListener('click', function () { select(o); }); });
    // Le thème change le prix quand on change de variante : on recalcule
    var priceEl = document.getElementById('ProductPrice-' + sectionId);
    if (priceEl && window.MutationObserver) new MutationObserver(refreshPrices).observe(priceEl, { childList: true, characterData: true, subtree: true });
    document.addEventListener('input', function (e) {
      if (e.target !== getQtyInput()) return;
      var match = null;
      options.forEach(function (o) { if (o.getAttribute('data-qty') === e.target.value) match = o; });
      options.forEach(function (o) { o.classList.toggle('is-selected', o === match); });
    });
  });

  /* ---------- Estimation de livraison (jours ouvrés, heure de Roumanie) ---------- */
  var ZILE = ['duminică', 'luni', 'marți', 'miercuri', 'joi', 'vineri', 'sâmbătă'];
  var LUNI = ['ian.', 'feb.', 'mar.', 'apr.', 'mai', 'iun.', 'iul.', 'aug.', 'sep.', 'oct.', 'nov.', 'dec.'];
  function bucharestNow() {
    try {
      var p = new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Bucharest', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }).formatToParts(new Date());
      var g = function (t) { return +p.find(function (x) { return x.type === t; }).value; };
      return new Date(g('year'), g('month') - 1, g('day'), g('hour'), g('minute'));
    } catch (e) { return new Date(); }
  }
  function addBusinessDays(date, n) {
    var d = new Date(date);
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
    return d;
  }
  function fmt(d) { return ZILE[d.getDay()] + ', ' + d.getDate() + ' ' + LUNI[d.getMonth()]; }
  document.querySelectorAll('[data-ev-delivery]').forEach(function (el) {
    var cutoff = +el.getAttribute('data-cutoff') || 14;
    var min = +el.getAttribute('data-min') || 1, max = +el.getAttribute('data-max') || 2;
    var update = function () {
      var now = bucharestNow();
      var weekday = now.getDay() !== 0 && now.getDay() !== 6;
      var shipsToday = weekday && now.getHours() < cutoff;
      var ship = shipsToday ? new Date(now) : addBusinessDays(now, 1);
      var from = addBusinessDays(ship, min), to = addBusinessDays(ship, max);
      el.querySelector('[data-ev-delivery-dates]').textContent = min === max ? fmt(from) : fmt(from) + ' – ' + fmt(to);
      var cut = el.querySelector('[data-ev-delivery-cutoff]');
      if (cut) {
        cut.hidden = !shipsToday;
        if (shipsToday) {
          var mins = cutoff * 60 - (now.getHours() * 60 + now.getMinutes());
          el.querySelector('[data-ev-delivery-left]').textContent = Math.floor(mins / 60) + 'h ' + (mins % 60) + 'min';
        }
      }
    };
    update();
    setInterval(update, 60000);
  });

  /* ---------- Complète ta routine ---------- */
  document.querySelectorAll('[data-ev-routine]').forEach(function (box) {
    // Mêmes paliers que les réductions automatiques Shopify : 2 articles / 3 articles et plus
    var off2 = +box.getAttribute('data-off') || 0;
    var off3 = +box.getAttribute('data-off-3') || off2;
    var items = box.querySelectorAll('[data-ev-routine-item]');
    var btn = box.querySelector('[data-ev-routine-add]');
    var label = btn.textContent;
    function refresh() {
      var total = 0, count = 0;
      items.forEach(function (i) { if (i.checked) { total += +i.getAttribute('data-price'); count++; } });
      var off = count >= 3 ? off3 : count === 2 ? off2 : 0;
      var withDiscount = off > 0;
      box.querySelector('[data-ev-routine-final]').textContent = money(withDiscount ? Math.round(total * (100 - off) / 100) : total);
      box.querySelector('[data-ev-routine-full]').textContent = withDiscount ? money(total) : '';
      btn.textContent = count === 1 ? 'Adaugă în coș' : label;
    }
    items.forEach(function (i) { i.addEventListener('change', refresh); });
    refresh();
    btn.addEventListener('click', function () {
      var payload = [];
      items.forEach(function (i) { if (i.checked) payload.push({ id: +i.getAttribute('data-variant'), quantity: 1 }); });
      btn.disabled = true;
      btn.textContent = 'Se adaugă…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: payload }) })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function () {
          btn.textContent = 'Adăugat în coș ✓';
          if (window.theme && theme.miniCart) { theme.miniCart.generateCart(); theme.miniCart.updateElements(); }
          // le panneau « Adăugat în coș » s'ouvre tout seul (voir plus bas)
          setTimeout(function () { btn.disabled = false; refresh(); }, 2500);
        })
        .catch(function () { btn.disabled = false; btn.textContent = label; });
    });
  });

  /* ---------- Bouton d'achat fixe (mobile) ---------- */
  document.querySelectorAll('[data-ev-sticky]').forEach(function (bar) {
    var sectionId = bar.getAttribute('data-section');
    // Le thème peut remplacer le bouton : on le relit à chaque fois
    var getMainBtn = function () { return document.getElementById('AddToCart-' + sectionId); };
    if (!getMainBtn()) return;
    document.body.appendChild(bar); // hors des conteneurs « sticky » du thème
    var ticking = false;
    var apply = function () {
      ticking = false;
      var btn = getMainBtn();
      var footer = document.querySelector('footer.site-footer');
      // on montre la barre une fois le bouton principal dépassé, et on la cache près du pied de page
      var passed = btn && btn.getBoundingClientRect().bottom < 0;
      var nearFooter = footer && footer.getBoundingClientRect().top < window.innerHeight;
      var show = !!(passed && !nearFooter && !btn.disabled);
      bar.hidden = !show;
      document.documentElement.classList.toggle('ev-sticky-visible', show);
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(apply); }
    }, { passive: true });
    apply();
    bar.querySelector('[data-ev-sticky-btn]').addEventListener('click', function () {
      var btn = getMainBtn();
      if (btn) btn.click();
    });
    var priceEl = document.getElementById('ProductPrice-' + sectionId);
    var stickyPrice = bar.querySelector('[data-ev-sticky-price]');
    if (priceEl && stickyPrice && window.MutationObserver) {
      new MutationObserver(function () { stickyPrice.textContent = priceEl.textContent.trim(); })
        .observe(priceEl, { childList: true, characterData: true, subtree: true });
    }
  });
})();

/* =========================================================
   Panneau « Adăugat în coș »
   Après chaque ajout au panier (fiche produit, cartes, aperçu rapide, routine,
   bouton fixe mobile) : le client reste sur la page et voit le produit ajouté,
   la livraison gratuite, la routine et le bouton « Vezi coșul ».
   Volet par le bas sur téléphone, panneau latéral sur tablette et ordinateur.
   Réglages : window.evCartDrawer (layout/theme.liquid).
   ========================================================= */
(function () {
  'use strict';
  var C = window.evCartDrawer;
  if (!C || /^\/cart\/?$/.test(location.pathname)) return;

  var ADD = /\/cart\/add(?:\.js)?$/;
  var drawer, panel, lastFocus, photoMap;

  function money(cents) {
    if (window.Shopify && Shopify.formatMoney && window.theme && theme.moneyFormat) return Shopify.formatMoney(cents, theme.moneyFormat);
    return new Intl.NumberFormat('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100) + ' lei';
  }
  function esc(text) {
    return String(text == null ? '' : text).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function shortTitle(title) { return String(title || '').split(' - ')[0]; }
  function photo(handle, fallback) {
    if (photoMap === undefined) {
      try { photoMap = JSON.parse(document.getElementById('ev-preview-photo-map').textContent); } catch (e) { photoMap = null; }
    }
    var p = photoMap && photoMap[handle] && photoMap[handle]['1'];
    if (p && p['360']) return p['360'];
    if (fallback && /cdn\.shopify\.com|\/cdn\/shop\//.test(fallback) && fallback.indexOf('width=') < 0) return fallback + (fallback.indexOf('?') < 0 ? '?' : '&') + 'width=160';
    return fallback || '';
  }
  function thumb(handle, fallback) {
    var src = photo(handle, fallback);
    return '<span class="ev-drawer__thumb">' + (src ? '<img src="' + esc(src) + '" alt="" width="64" height="64" loading="lazy">' : '') + '</span>';
  }

  /* ---------- Repérer les ajouts au panier, d'où qu'ils viennent ---------- */
  function isAdd(url, method) {
    if (String(method || 'GET').toUpperCase() !== 'POST') return false;
    try { return ADD.test(new URL(url, location.href).pathname); } catch (e) { return false; }
  }
  function isGift(body) {
    // l'ajout automatique du cadeau ne doit pas ouvrir le panneau
    if (typeof body === 'string') return body.indexOf('_Cadou') > -1;
    if (window.FormData && body instanceof FormData) return body.has('properties[_Cadou]');
    return false;
  }
  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = (init && init.method) || (input && input.method) || 'GET';
      var request = nativeFetch.apply(this, arguments);
      if (isAdd(url, method) && !isGift(init && init.body)) {
        request.then(function (r) { if (r.ok) r.clone().json().then(added, function () {}); }, function () {});
      }
      return request;
    };
  }
  var xhrOpen = XMLHttpRequest.prototype.open, xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.evCartAdd = isAdd(url, method);
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    var xhr = this;
    if (xhr.evCartAdd && !isGift(body)) {
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) { try { added(JSON.parse(xhr.responseText)); } catch (e) {} }
      });
    }
    return xhrSend.apply(this, arguments);
  };

  // Formulaires classiques (page Hydra Booster…) : ajout sans quitter la page.
  // Ceux que le thème gère déjà en Ajax ont defaultPrevented et ne sont pas touchés.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (e.defaultPrevented || !form || !form.action || !isAdd(form.action, form.method || 'get')) return;
    e.preventDefault();
    var button = e.submitter || form.querySelector('[type="submit"]');
    if (button) { button.disabled = true; button.classList.add('is-loading'); }
    window.fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; }); })
      .catch(function (error) {
        var message = (error && error.description) || 'Nu am putut adăuga produsul în coș. Încearcă din nou.';
        if (window.theme && theme.alert) theme.alert.new('', message, 4000, 'warning'); else window.alert(message);
      })
      .then(function () { if (button) { button.disabled = false; button.classList.remove('is-loading'); } });
  });

  // L'ancienne petite notification grise fait doublon avec le panneau
  if (window.theme && theme.alert && theme.strings) {
    var alertNew = theme.alert.new;
    theme.alert.new = function (title) {
      if (title && title === theme.strings.addToCartSuccess) return;
      return alertNew.apply(this, arguments);
    };
  }

  /* ---------- Panneau ---------- */
  function build() {
    drawer = document.createElement('div');
    drawer.className = 'ev-drawer';
    drawer.hidden = true;
    drawer.innerHTML =
      '<div class="ev-drawer__backdrop" data-ev-drawer-close></div>' +
      '<div class="ev-drawer__panel" role="dialog" aria-modal="true" aria-labelledby="ev-drawer-title" tabindex="-1">' +
        '<div class="ev-drawer__head" data-ev-drawer-drag>' +
          '<span class="ev-drawer__handle" aria-hidden="true"></span>' +
          '<p class="ev-drawer__title" id="ev-drawer-title"><span class="ev-drawer__check" aria-hidden="true">✓</span> Adăugat în coș</p>' +
          '<button type="button" class="ev-drawer__close" data-ev-drawer-close aria-label="Închide">&times;</button>' +
        '</div>' +
        '<div class="ev-drawer__body" data-ev-drawer-body></div>' +
        '<div class="ev-drawer__foot" data-ev-drawer-foot></div>' +
      '</div>';
    document.body.appendChild(drawer);
    panel = drawer.querySelector('.ev-drawer__panel');

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-ev-drawer-close]')) { e.preventDefault(); close(); return; }
      var add = e.target.closest('[data-ev-drawer-add]');
      if (add) addUpsell(add);
    });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var nodes = panel.querySelectorAll('a[href], button:not([disabled])');
      if (!nodes.length) return;
      var first = nodes[0], last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    // Téléphone : glisser le haut du volet vers le bas pour le fermer
    var head = drawer.querySelector('[data-ev-drawer-drag]'), startY = null, deltaY = 0;
    var isPhone = function () { return window.matchMedia('(max-width: 749px)').matches; };
    head.addEventListener('touchstart', function (e) { startY = e.touches[0].clientY; deltaY = 0; panel.style.transition = 'none'; }, { passive: true });
    head.addEventListener('touchmove', function (e) {
      if (startY === null) return;
      deltaY = Math.max(0, e.touches[0].clientY - startY);
      if (isPhone()) panel.style.transform = 'translateY(' + deltaY + 'px)';
    }, { passive: true });
    head.addEventListener('touchend', function () {
      panel.style.transition = '';
      panel.style.transform = '';
      if (deltaY > 80 && isPhone()) close();
      startY = null;
    });
  }

  function render(items, cart) {
    var html = '<ul class="ev-drawer__added">';
    items.forEach(function (item) {
      var variant = item.variant_title && !/Default/.test(item.variant_title) ? '<span class="ev-drawer__meta">' + esc(item.variant_title) + '</span>' : '';
      html += '<li class="ev-drawer__item">' + thumb(item.handle, item.image) +
        '<span class="ev-drawer__info"><a class="ev-drawer__name" href="' + esc(item.url) + '">' + esc(shortTitle(item.product_title)) + '</a>' + variant +
        '<span class="ev-drawer__meta">În coș: ' + item.quantity + ' buc.</span></span>' +
        '<strong class="ev-drawer__price">' + money(item.final_line_price) + '</strong></li>';
    });
    html += '</ul>';

    // Livraison gratuite puis échantillon cadeau, chacun avec sa barre
    var perks = '';
    function perk(text, percent, done, label) {
      return '<div class="ev-drawer__perk' + (done ? ' is-done' : '') + '"><p>' + text + '</p>' +
        '<div class="ev-drawer__track" role="progressbar" aria-label="' + label + '" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + percent + '"><div class="ev-drawer__bar" style="width:' + percent + '%"></div></div></div>';
    }
    if (C.freeShipping > 0) {
      var left = C.freeShipping - cart.total_price;
      perks += perk(left <= 0 ? '<strong>Felicitări, ai livrare gratuită!</strong>' : 'Mai adaugă <strong>' + money(left) + '</strong> și ai <strong>livrare gratuită</strong>.',
        Math.min(100, Math.round(cart.total_price * 100 / C.freeShipping)), left <= 0, 'Progres spre livrarea gratuită');
    }
    if (window.evGift) {
      var g = window.evGift.state(cart);
      perks += perk(window.evGift.text(cart), Math.min(100, Math.round(g.paid * 100 / window.evGift.config.threshold)), g.reached, 'Progres spre mostra cadou');
    }
    if (perks) html += '<div class="ev-drawer__ship">' + perks + '</div>';

    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.handle] = true; });
    var upsell = (C.products || []).filter(function (p) { return !inCart[p.handle]; }).slice(0, 2);
    if (upsell.length) {
      html += '<div class="ev-drawer__upsell"><p class="ev-drawer__upsell-title">Completează-ți rutina</p><ul>';
      upsell.forEach(function (p) {
        html += '<li class="ev-drawer__item">' + thumb(p.handle, p.image) +
          '<span class="ev-drawer__info"><a class="ev-drawer__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a><span class="ev-drawer__meta">' + money(p.price) + '</span></span>' +
          '<button type="button" class="ev-btn ev-btn--outline ev-drawer__add" data-ev-drawer-add="' + p.variant + '">Adaugă</button></li>';
      });
      html += '</ul></div>';
    }
    html += '<p class="ev-drawer__error" role="alert" data-ev-drawer-error></p>';
    drawer.querySelector('[data-ev-drawer-body]').innerHTML = html;

    drawer.querySelector('[data-ev-drawer-foot]').innerHTML =
      '<p class="ev-drawer__total"><span>Total coș (' + cart.item_count + (cart.item_count === 1 ? ' produs' : ' produse') + ')</span><strong>' + money(cart.total_price) + '</strong></p>' +
      '<a class="ev-btn ev-drawer__cart" href="/cart">Vezi coșul</a>' +
      '<button type="button" class="ev-drawer__continue" data-ev-drawer-close>Continuă cumpărăturile</button>';
    document.querySelectorAll('.js-cart-count').forEach(function (n) { n.textContent = cart.item_count; });
  }

  function open() {
    if (!drawer.hidden && drawer.classList.contains('is-open')) return;
    if (document.activeElement && !drawer.contains(document.activeElement)) lastFocus = document.activeElement;
    // fermer l'aperçu rapide s'il est ouvert
    if (window.jQuery) { try { jQuery('.modal.show').modal('hide'); } catch (e) {} }
    drawer.hidden = false;
    document.documentElement.classList.add('ev-drawer-open');
    void drawer.offsetHeight; // force le navigateur à poser l'état fermé avant l'animation
    drawer.classList.add('is-open');
    panel.focus({ preventScroll: true });
  }
  function close() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('ev-drawer-open');
    setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  function added(data) {
    var items = data && data.items ? data.items : [data];
    if (!items.length || !items[0] || !items[0].variant_id) return;
    if (!drawer) build();
    nativeFetch.call(window, '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return window.evGift ? window.evGift.sync(cart) : cart; })
      .then(function (cart) { render(items, cart); open(); })
      .catch(function () {});
  }

  function addUpsell(button) {
    var label = button.textContent;
    button.disabled = true;
    button.textContent = '…';
    window.fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: +button.getAttribute('data-ev-drawer-add'), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (d) { throw d; });
      if (window.theme && theme.miniCart) { theme.miniCart.updateElements(); theme.miniCart.generateCart(); }
    }).catch(function (error) {
      button.disabled = false;
      button.textContent = label;
      var box = drawer.querySelector('[data-ev-drawer-error]');
      if (box) box.textContent = (error && error.description) || 'Nu am putut adăuga produsul. Încearcă din nou.';
    });
  }
})();
